export const TWO_LINES_HEIGHT = 124;
